import {
  COURSE_SLUG_SAT_BOOTCAMP_MATH,
  COURSE_SLUG_SAT_BOOTCAMP_READING,
} from '@/queries/constants'

import type { SATBootcampCourseSlug } from './types'

export default function isSATBootcampCourseSlug(
  slug?: string | null
): slug is SATBootcampCourseSlug {
  return slug === COURSE_SLUG_SAT_BOOTCAMP_MATH || slug === COURSE_SLUG_SAT_BOOTCAMP_READING
}
